module.exports = __webpack_public_path__ + "img/empty-list.972e0867.svg";